import { Box, Typography } from "@mui/material"

export function VersionInfoRow({ label, value }) {
    return (
        <Typography sx={{ fontSize: "9.5px", lineHeight: 1.5, color: "#7b8794" }}>
            <Box component="span" sx={{ fontWeight: 700, color: "#4b5563" }}>
                {label}:
            </Box>{" "}
            {value || "—"}
        </Typography>
    )
}
